import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/layout/Navbar";
import { BottomNav } from "@/components/layout/BottomNav";
import { Footer } from "@/components/layout/Footer";

/**
 * Main application shell.
 *
 * Structure:
 *   <Navbar />
 *   <main>{page content via <Outlet />}</main>
 *   <Footer /> (md+)
 *   <BottomNav /> (mobile only)
 *
 * Pages should apply `.tsgo-page` on their root to reserve bottom padding
 * for the mobile bottom navigation.
 */
export function AppLayout() {
    return (
        <div className="flex min-h-screen flex-col bg-background text-foreground">
            <Navbar />
            <main
                id="main-content"
                data-testid="app-main"
                className="flex-1 animate-fade-in"
            >
                <Outlet />
            </main>
            <Footer />
            <BottomNav />
        </div>
    );
}

export default AppLayout;
